/* Great Lakes Lavender Farm — site-wide accessibility repairs (WCAG 2.2 AA).
   Fixes markup coming from the theme and installed apps without editing them.
   Runs on load and again whenever apps inject new content. Safe to run many times. */
(function () {
  'use strict';
  if (window.__gllfA11y) return;
  window.__gllfA11y = true;

  var FOCUSABLE = 'a[href],button,input:not([type="hidden"]),select,textarea,summary,[tabindex]:not([tabindex="-1"])';

  function labelText(el) {
    return (el.getAttribute('aria-label') || el.getAttribute('placeholder') || el.getAttribute('title') || el.name || '').trim();
  }
  function hasLabel(el) {
    if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby') || el.closest('label')) return true;
    if (el.id) { try { if (document.querySelector('label[for="' + CSS.escape(el.id) + '"]')) return true; } catch (e) {} }
    return false;
  }

  /* 1. Form fields without a programmatic label (1.3.1 / 4.1.2) */
  var SELECT_NAMES = { glrTypeFilter: 'Filter reviews by type', glrVariantFilter: 'Filter reviews by size', glrSort: 'Sort reviews' };
  function fixLabels(root) {
    root.querySelectorAll('input:not([type="hidden"]):not([type="submit"]):not([type="button"]), select, textarea').forEach(function (el) {
      if (hasLabel(el)) return;
      // Spam honeypots should be invisible to everyone, including screen readers and keyboards.
      if (/honeypot|hp-|bot-field/i.test(el.className + ' ' + (el.name || '') + ' ' + (el.id || ''))) {
        el.setAttribute('aria-hidden', 'true'); el.setAttribute('tabindex', '-1'); el.setAttribute('autocomplete', 'off'); el.setAttribute('aria-label', 'Leave this field empty');
        return;
      }
      var name = SELECT_NAMES[el.id] || labelText(el);
      if (!name && el.type === 'email') name = 'Email address';
      if (!name && el.type === 'search') name = 'Search';
      if (name) el.setAttribute('aria-label', name.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').replace(/^\w/, function (c) { return c.toUpperCase(); }));
    });
  }

  /* 2. Focusable elements hidden from screen readers (4.1.2 aria-hidden-focus) */
  function fixHiddenFocus(root) {
    root.querySelectorAll('[aria-hidden="true"]').forEach(function (el) {
      if (el.matches(FOCUSABLE) && el.getClientRects().length) { el.removeAttribute('aria-hidden'); return; }
    });
  }

  /* 3. Broken ARIA references (4.1.2) */
  function fixAria(root) {
    ['aria-owns', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach(function (attr) {
      root.querySelectorAll('[' + attr + ']').forEach(function (el) {
        var ids = (el.getAttribute(attr) || '').split(/\s+/).filter(Boolean);
        var ok = ids.filter(function (id) { return document.getElementById(id); });
        if (attr === 'aria-controls' || attr === 'aria-owns') { if (!ok.length) el.removeAttribute(attr); else if (ok.length !== ids.length) el.setAttribute(attr, ok.join(' ')); }
        else if (!ok.length && !el.textContent.trim() && !el.getAttribute('aria-label')) { /* leave – nothing better to point to */ }
      });
    });
  }

  /* 3b. Tab lists that contain plain links (4.1.2 aria-required-children) */
  function fixTablists(root) {
    root.querySelectorAll('[role="tablist"]').forEach(function (list) {
      Array.prototype.forEach.call(list.children, function (c) {
        if (c.matches('a[href]') && !c.getAttribute('role')) { c.setAttribute('role', 'tab'); c.setAttribute('aria-selected', 'false'); }
      });
    });
  }

  /* 4. Landmarks & headings (1.3.1 / 2.4.1 / 2.4.6) */
  function fixStructure() {
    // The site footer sits inside a <section>, so browsers don't treat it as the page footer landmark.
    var footer = document.querySelector('footer.gf') || document.querySelector('#shopify-section-group-footer-group footer') || document.querySelector('footer');
    if (footer) {
      document.querySelectorAll('[role="contentinfo"]').forEach(function (f) { if (f !== footer && !f.textContent.trim()) f.removeAttribute('role'); });
      footer.setAttribute('role', 'contentinfo');
    }
    // Announcement bar / notices above the header: give them a labeled region
    document.querySelectorAll('.gllf-notice, .announcement-bar, .utility-bar').forEach(function (n) {
      if (!n.closest('header, [role="banner"], [role="region"], main, footer') && !n.getAttribute('role')) { n.setAttribute('role', 'region'); n.setAttribute('aria-label', 'Store announcement'); }
    });
    // Nested <main> landmarks (e.g. community app inside the theme's main)
    var mains = document.querySelectorAll('main, [role="main"]');
    if (mains.length > 1) {
      Array.prototype.slice.call(mains, 1).forEach(function (m) {
        if (m.closest('main, [role="main"]') !== m || m.parentElement.closest('main, [role="main"]')) { m.setAttribute('role', 'region'); if (!m.getAttribute('aria-label')) m.setAttribute('aria-label', 'Page content'); }
      });
    }
    // Exactly one visible <h1> per page: demote the logo h1 on pages that already have one
    var main = document.getElementById('MainContent') || document.querySelector('main');
    var h1s = Array.prototype.filter.call(document.querySelectorAll('h1'), function (h) { return h.getClientRects().length; });
    var mainH1 = h1s.filter(function (h) { return main && main.contains(h); });
    h1s.forEach(function (h) {
      if (mainH1.length && !(main && main.contains(h)) && h.closest('header, .header, sticky-header, .header-wrapper')) h.setAttribute('role', 'presentation');
    });
    // Pages with no h1 at all (e.g. app-rendered Wishlist/Events): add one for screen readers
    if (main && !main.querySelector('h1') && !document.getElementById('GLLFA11yH1')) {
      var t = document.createElement('h1'); t.id = 'GLLFA11yH1'; t.className = 'gllf-sr-only';
      t.textContent = (document.title || '').split(/\s[–|-]\s/)[0].trim() || 'Great Lakes Lavender Farm';
      main.insertBefore(t, main.firstChild);
    }
    // Asides nested inside other landmarks: keep content, drop the duplicate landmark role
    var LANDMARK = 'main, header, footer, nav, aside, [role="main"], [role="banner"], [role="contentinfo"], [role="navigation"], [role="region"], [role="complementary"], section[aria-label], section[aria-labelledby]';
    document.querySelectorAll('aside').forEach(function (a) {
      if (a.getAttribute('role') || !a.parentElement || !a.parentElement.closest(LANDMARK)) return;
      a.setAttribute('role', (a.getAttribute('aria-label') || a.getAttribute('aria-labelledby')) ? 'region' : 'presentation');
    });
  }

  /* 5. Tiny text: raise anything under 12px to 12px for readability (1.4.4 support; 50+ audience) */
  function fixTinyText(root) {
    var skip = /badge|count|bubble|tag|chip|price--|sp-n|gllf-mega-tag|visually-hidden|sr-only/i;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.textContent.trim().length > 2 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; }
    });
    var seen = new Set(), n, count = 0;
    while ((n = walker.nextNode()) && count < 3000) {
      count++;
      var el = n.parentElement;
      if (!el || seen.has(el) || el.classList.contains('gllf-a11y-min-text')) continue;
      seen.add(el);
      if (skip.test(el.className) || (el.parentElement && skip.test(el.parentElement.className))) continue;
      if (el.closest('svg, script, style, noscript, [aria-hidden="true"], .gllf-header-count, .cart-count-bubble')) continue;
      var fs = parseFloat(getComputedStyle(el).fontSize);
      if (fs && fs < 12 && el.getClientRects().length) el.classList.add('gllf-a11y-min-text');
    }
  }

  /* 6. Links that open in a new tab: tell screen-reader users (3.2.5 / G201) */
  function fixNewTab(root) {
    root.querySelectorAll('a[target="_blank"]:not([data-gllf-nt])').forEach(function (a) {
      a.setAttribute('data-gllf-nt', '1');
      if (!/noopener/.test(a.rel || '')) a.rel = ((a.rel || '') + ' noopener').trim();
      var s = document.createElement('span'); s.className = 'gllf-sr-only'; s.textContent = ' (opens in a new tab)';
      if (a.getAttribute('aria-label')) { if (!/new tab/i.test(a.getAttribute('aria-label'))) a.setAttribute('aria-label', a.getAttribute('aria-label') + ' (opens in a new tab)'); }
      else a.appendChild(s);
    });
  }

  /* 7. Images with no alt at all: skip them when the link/button already has text (1.1.1) */
  function fixImages(root) {
    root.querySelectorAll('img:not([alt])').forEach(function (img) {
      var host = img.closest('a, button');
      if (host && host.textContent.trim()) img.setAttribute('alt', '');
      else if (img.getAttribute('title')) img.setAttribute('alt', img.getAttribute('title'));
    });
  }

  /* 8. Icon-only buttons/links with no name (4.1.2) */
  function fixNames(root) {
    root.querySelectorAll('button, a[href]').forEach(function (b) {
      if (b.getAttribute('aria-label') || b.getAttribute('aria-labelledby') || b.textContent.trim()) return;
      var t = b.getAttribute('title') || (b.querySelector('img[alt]') && b.querySelector('img[alt]').alt) || '';
      if (!t) {
        var c = (b.className || '') + ' ' + (b.getAttribute('href') || '');
        t = /close/i.test(c) ? 'Close' : /cart/i.test(c) ? 'Cart' : /search/i.test(c) ? 'Search' : /prev/i.test(c) ? 'Previous' : /next/i.test(c) ? 'Next' : /instagram/i.test(c) ? 'Instagram' : /facebook/i.test(c) ? 'Facebook' : '';
      }
      if (t) b.setAttribute('aria-label', t);
    });
  }

  function run(root) {
    root = root || document;
    try { fixLabels(root); } catch (e) {}
    try { fixHiddenFocus(root); } catch (e) {}
    try { fixAria(root); } catch (e) {}
    try { fixTablists(root); } catch (e) {}
    try { fixNewTab(root); } catch (e) {}
    try { fixImages(root); } catch (e) {}
    try { fixNames(root); } catch (e) {}
    try { fixTinyText(root === document ? document.body : root); } catch (e) {}
  }

  function boot() {
    run(document);
    try { fixStructure(); } catch (e) {}
    // Apps (reviews, community, chat, saved & compare) render late: re-run on new content.
    var pending = null, roots = [];
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1 || n.classList.contains('gllf-sr-only')) return;
        /* the farm simulator redraws small panels every second (e.g. the farm weather card): size their text before the
           screen paints, otherwise it shows small for a moment and then jumps bigger — a visible pulse */
        if (n.closest && n.closest('#lfg-simulator-root') && n.getElementsByTagName('*').length < 400) { try { fixTinyText(n); } catch (e) {} return; }
        roots.push(n);
      }); });
      if (!roots.length || pending) return;
      pending = setTimeout(function () {
        var batch = roots.splice(0); pending = null;
        batch.forEach(function (r) { if (r.isConnected) run(r); });
        try { fixStructure(); } catch (e) {}
      }, 250);
    }).observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { run(document); fixStructure(); }, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
